/* ============================================================
   MM: Split-Flap - Produkttitel wie eine Flughafenanzeige.

   Echte Solari-Mechanik: Jede Walze laeuft durchs Alphabet weiter,
   bis sie ihren Buchstaben erreicht, und haelt dann an. Die Walzen
   starten versetzt, dadurch laeuft die Welle von links nach rechts.

   Ablauf: leer -> MAINEY -> kurz halten -> echter Produkttitel.
   ============================================================ */
(function () {
  'use strict';

  var ALPHABET = ' ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789&-.\'/';
  var TICK = 42;        /* Zeit pro Walzenschritt (ms) */
  var STAGGER = 28;     /* Versatz zwischen benachbarten Walzen (ms) */
  var HOLD = 520;       /* Wie lange MAINEY stehen bleibt (ms) */
  var WORD = 'MAINEY';
  var MAX_CHARS = 64;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  function findTitle(card) {
    return card.querySelector(
      '.product-title, [class*="product-title"], [class*="card__title"], [class*="card-title"], h2, h3'
    );
  }

  function idx(ch) {
    var i = ALPHABET.indexOf(ch);
    return i === -1 ? 0 : i;
  }

  /* Zentriert MAINEY in einer Zeile der Laenge len */
  function centered(word, len) {
    if (len <= word.length) return word.slice(0, len);
    var left = Math.floor((len - word.length) / 2);
    var out = '';
    for (var i = 0; i < len; i++) {
      out += (i >= left && i < left + word.length) ? word.charAt(i - left) : ' ';
    }
    return out;
  }

  function Board(el, finalText) {
    this.el = el;
    this.finalText = finalText;
    this.len = finalText.length;
    this.cells = [];
    for (var i = 0; i < this.len; i++) this.cells.push(0); /* alle auf Leerzeichen */
    this.timer = null;
  }

  Board.prototype.paint = function () {
    var out = '';
    for (var i = 0; i < this.len; i++) out += ALPHABET.charAt(this.cells[i]);
    this.el.textContent = out;
  };

  /* Laesst alle Walzen bis zum Ziel weiterlaufen, versetzt gestartet */
  Board.prototype.flapTo = function (target, done) {
    var self = this;
    var elapsed = 0;
    var targets = [];
    for (var i = 0; i < this.len; i++) {
      targets.push(idx(target.charAt(i).toUpperCase()));
    }

    clearInterval(this.timer);
    this.timer = setInterval(function () {
      elapsed += TICK;
      var moving = false;

      for (var i = 0; i < self.len; i++) {
        if (elapsed < i * STAGGER) { moving = true; continue; }
        if (self.cells[i] !== targets[i]) {
          self.cells[i] = (self.cells[i] + 1) % ALPHABET.length;
          moving = true;
        }
      }

      self.paint();

      if (!moving) {
        clearInterval(self.timer);
        self.timer = null;
        if (done) done();
      }
    }, TICK);
  };

  function run(el) {
    if (el.dataset.mmFlap === 'done') return;
    el.dataset.mmFlap = 'done';

    var finalText = (el.textContent || '').trim();
    if (!finalText || finalText.length > MAX_CHARS) return;

    /* Masse einfrieren, sonst springt das Layout bei jedem Zeichenwechsel */
    var rect = el.getBoundingClientRect();
    el.style.minWidth = Math.ceil(rect.width) + 'px';
    el.style.minHeight = Math.ceil(rect.height) + 'px';

    var board = new Board(el, finalText);
    board.paint();

    board.flapTo(centered(WORD, finalText.length), function () {
      setTimeout(function () {
        board.flapTo(finalText, function () {
          el.textContent = finalText;
          el.style.minWidth = '';
          el.style.minHeight = '';
        });
      }, HOLD);
    });
  }

  function init() {
    var cards = document.querySelectorAll('.product-card');
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        var t = findTitle(card);
        if (t) run(t);
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var title = findTitle(entry.target);
        if (title) run(title);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.25 });

    cards.forEach(function (card) {
      if (card.dataset.mmFlapWatched === '1') return;
      card.dataset.mmFlapWatched = '1';
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('popstate', function () { setTimeout(init, 400); });
})();
